import Auth from "@/helpers/middleware";
import SysMsg from "@/helpers/system.message";
import UsersServices from "@/services/users.services";

export default {
  name: "account",
  data() {
    return {
      loading: false,
      user: {},
      controller: {
        title: "Mi Cuenta",
        mainRouter: "/micuenta"
      },
      accesos: Auth.getDepartments(),
      name: null,
      password: {
        current: "",
        new: "",
        confirm: ""
      },
      send: {
        statusId: 0,
        nombre: null,
        email: null,
        clave: null,
        clave_nueva: null,
        usuario: null,
        id_sistema: null
      },
      updatePassword: false,
      hideEdit: false
    };
  },
  watch: {
    user: {
      deep: true,
      handler(data) {
        this.send.statusId = data.status.id;
        this.send.email = data.email;
        this.send.usuario = data.email;
        this.send.id_sistema = data.id_sistema ? data.id_sistema : 1;
      }
    },
    password: {
      deep: true,
      handler(data) {
        this.hideEdit = data.new.trim().length + data.confirm.trim().length > 0;
        this.updatePassword =
          this.hideEdit && data.new.trim() == data.confirm.trim();
        this.send.clave =
          this.hideEdit && this.updatePassword && data.current.trim().length > 0
            ? data.current
            : null;
        this.send.clave_nueva =
          this.hideEdit && this.updatePassword && data.current.trim().length > 0
            ? data.new
            : null;
      }
    }
  },
  computed: {
    updatePasswordClass: {
      get() {
        let passwordNew = this.password.new ? this.password.new.trim() : "";
        let passwordConfirm = this.password.confirm
          ? this.password.confirm.trim()
          : "";

        return passwordNew.trim().length + passwordConfirm.trim().length == 0
          ? ""
          : passwordNew.trim().length + passwordConfirm.trim().length > 0 &&
            passwordNew.trim() != passwordConfirm.trim()
            ? "has-danger"
            : "has-success";
      }
    },
    updateData: {
      get() {
        return this.user.name.trim() != this.send.nombre.trim();
      }
    }
  },
  created() {
    this.user = Auth.getUser();
    this.send.nombre = this.user.name;
    this.accesos = Auth.getDepartments();
  },
  methods: {
    logout() {
      Auth.logOut();
    },
    updateInfo() {
      this.loading = true;
      UsersServices.login
        .update(this.send)
        .then(response => {
          this.loading = false;
          if (response.data.result.status == 1) {
            this.user.name = this.send.nombre;
            Auth.setLocalStorage(this.user);
            SysMsg.getMessage("Usuario Actualizado correctamente", "info");
            this.clearSend();
          } else if (this.password.current.trim().length > 0) {
            SysMsg.getMessage("La contraseña actual no es valida", "warning");
          } else {
            SysMsg.getMessage(
              "Ocurrio un error, favor intentar más tarde",
              "error"
            );
          }
        })
        .catch(error => {
          this.loading = false;
          SysMsg.getResponseMessage(error.response);
        });
    },
    clearSend() {
      this.send.clave = null;
      this.send.clave_nueva = null;
      this.password.current = "";
      this.password.new = "";
      this.password.confirm = "";
    }
  }
};